import { Modal } from 'antd'

export function DataInsertModal({
    isOpen = false, isAdd = false, isEdit = false, handleDataValue = () => { }, handleModelClose = () => { },
    children, title, className = ""
}) {
    return (
        <>
            <Modal
                className={className}
                title={title}
                open={isOpen}
                okText={isEdit ? "Update" : "ADD"}
                onOk={handleDataValue}
                onCancel={handleModelClose}
                okButtonProps={{
                    className: 'px-5 py-3',
                    size: 'small',
                }}
                cancelButtonProps={{
                    className: 'px-5 py-3',
                    size: 'small',
                }}
            >
                <div className='py-3'>
                    {children}
                </div>
            </Modal>
        </>
    )
}

export default DataInsertModal
